/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchFilterRequestDTOFromJSON, SearchFilterRequestDTOToJSON, } from './SearchFilterRequestDTO';
/**
 * Check if a given object implements the DeleteSearchRequestDTO interface.
 */
export function instanceOfDeleteSearchRequestDTO(value) {
    return true;
}
export function DeleteSearchRequestDTOFromJSON(json) {
    return DeleteSearchRequestDTOFromJSONTyped(json, false);
}
export function DeleteSearchRequestDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'selectAll': json['selectAll'] == null ? undefined : json['selectAll'],
        'searchIds': json['searchIds'] == null ? undefined : json['searchIds'],
        'filters': json['filters'] == null ? undefined : SearchFilterRequestDTOFromJSON(json['filters']),
    };
}
export function DeleteSearchRequestDTOToJSON(json) {
    return DeleteSearchRequestDTOToJSONTyped(json, false);
}
export function DeleteSearchRequestDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'selectAll': value['selectAll'],
        'searchIds': value['searchIds'],
        'filters': SearchFilterRequestDTOToJSON(value['filters']),
    };
}
